<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý model sản phẩm</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <div class="box-top-list">

          <span class="p-m-0">{{ titleModel }}</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData" />
          </span>
        </div>
        <div class="list-data">
          <TabView @tab-change="click_tab_menu" >
            <TabPanel @click="click_tab_menu(0)" :key="'0'" :active="active_tab.tab_0"  header="Thông tin chung" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-md-6">
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="model_code">Model sản phẩm <span class="error">*</span></label>
                      <InputText @keyup="changeModelCode" :disabled="disabled" id="model_code" type="text" v-model="model_code" maxlength="255" />
                      <small v-if="validationErrors && validationErrors['model_code']"
                          class="p-invalid" >{{validationErrors['model_code']}}</small>
                      <small v-if="model_code_exists"
                      class="p-invalid" >Model sản phẩm bị trùng</small>
                    </div>
                  </div>

                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="name">Tên sản phẩm  <span class="error">*</span></label>
                      <InputText  id="name" type="text" v-model="name" maxlength="255"/>
                      <small v-if="validationErrors && validationErrors['name']"
                          class="p-invalid" >{{validationErrors['name']}}</small>
                      <small v-if="model_name_exists"
                      class="p-invalid" >Tên sản phẩm bị trùng</small>
                    </div>
                  </div>

                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="category_id">Nhóm sản phẩm <span class="error">*</span></label>
                      <Dropdown :filter="true" @change="changeCategories" inputId="category_id" v-model="category_id" :options="optionsCategories" optionLabel="label"  optionValue="value" placeholder="Chọn nhóm sản phẩm"/>
                      <small v-if="validationErrors && validationErrors['category_id']"
                          class="p-invalid" >{{validationErrors['category_id']}}</small>
                    </div>
                  </div>


                  <div class="p-field p-col-12">
                    <div class="p-col-8 p-md-0 p-grid">
                      <div class="p-col-6">
                        <div class="p-field">
                          <label for="warranty_time">Thời hạn bảo hành  <span class="error">*</span></label>
                          <div class="p-grid">
                            <div class="p-col-8 p-field">
                              <InputNumber id="warranty_time" type="text" :min="0" v-model="warranty_time"/>
                            </div>
                            <div class="p-col-3 p-field unit-custom">
                              <label >Tháng</label>
                            </div>
                            <small v-if="validationErrors && validationErrors['warranty_time']"
                            class="p-invalid" >{{validationErrors['warranty_time']}}</small>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-6">
                        <div class="p-field">
                          <label for="change_time">Thời hạn đổi</label>
                          <div class="p-grid">
                            <div class="p-col-8 p-field">
                              <InputNumber  id="change_time" :min="-1" type="text"  v-model="change_time"/>
                            </div>
                            <div class="p-col-3 p-field unit-custom">
                              <label >Ngày</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="p-field p-col-12">
                    <div class="p-col-8 p-md-0 p-grid">
                      <div class="p-col-6">
                        <div class="p-field p-col-12">
                          <label for="returnable_time">Thời hạn trả (tự duyệt)</label>
                          <div class="p-grid">
                            <div class="p-col-8 p-field">
                              <InputNumber  id="returnable_time" :min="-1" type="text"  v-model="returnable_time"/>
                            </div>
                            <div class="p-col-3 p-field unit-custom">
                              <label >Ngày</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="p-col-6">
                        <div class="p-field p-col-12">
                          <label for="returnable_time">Thời hạn trả (thẩm định)</label>
                          <div class="p-grid">
                            <div class="p-col-8 p-field">
                              <InputNumber  id="returnable_appraisal_time" :min="-1" type="text"  v-model="returnable_appraisal_time"/>
                            </div>
                            <div class="p-col-3 p-field unit-custom">
                              <label >Ngày</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="production_status">Trạng thái sản xuất <span class="error">*</span></label>
                      <Dropdown  inputId="production_status" v-model="productionStatus" :options="optionStatus" optionLabel="label"  optionValue="value" />
                    </div>
                  </div>
                </div>
                <div class=" p-md-6">
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="zip">Mẫu QR Code <span class="error">*</span></label>
                      <Dropdown  v-model="qr_code_size" :options="qrCodeSizes" optionLabel="label" optionValue="value" placeholder="Chọn mẫu QR Code"/>
                      <small v-if="validationErrors && validationErrors['qr_code_size']"
                          class="p-invalid" >{{validationErrors['qr_code_size']}}</small>
                      <div class="box-qrcode-product">
                      <templateSerialNumber :key="componentKeyQRcode" class="custom-qr-code" :title="title" :note="note" :hotline="hotline" :codeValue="$myConstants.getUrlChecker() + '/check-warranty-detail/' + serialNumber" :modelCode="model_code" :serialNumber="serialNumber"/>
                      </div>
                    </div>
                  </div>
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="lastname">Hình ảnh sản phẩm</label>
                      <div class="p-field">
                        <Button :label="'Chọn'" icon="pi pi-plus" @click="openFile" />
                        <input id="files" ref="files" type="file" style="display:none" @change="chooseFile"/>
                      </div>
                      <div class="box-img-product" v-if="productImages && productImages.length">
                        <img :key="indexImg" v-for="(itemImg, indexImg) in productImages" :src="itemImg.objectURL" width="200"/>
                      </div>
                      <div class="box-img-product" v-else>
                        <img :src="logoPortal" width="200"/>
                      </div>
                    </div>
                  </div>
                  <div class="p-field p-col-12" style="padding-bottom: 0px !important;">
                    <p style="font-weight: bold;margin-bottom: 0px;">Hướng dẫn sử dụng</p>
                  </div>
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="name">Link PDF</label>
                      <InputText  id="link_pdf" type="text" v-model="link_pdf" maxlength="500"/>
                      <small v-if="validationErrors && validationErrors['link_pdf']"
                             class="p-invalid" >{{validationErrors['link_pdf']}}</small>
                    </div>
                  </div>
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label for="name">Link Youtube</label>
                      <InputText  id="link_youtube" type="text" v-model="link_youtube" maxlength="500"/>
                      <small v-if="validationErrors && validationErrors['link_youtube']"
                             class="p-invalid" >{{validationErrors['link_youtube']}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel :key="'1'" @click="click_tab_menu(1)"  :active="active_tab.tab_1"  header="Mô tả sản phẩm" >
              <div class="p-fluid p-formgrid p-grid">
                <!-- <div class="p-field p-col-12">
                  <label for="description">Mô tả</label>
                  <Textarea  id="description" rows="5"  v-model="description" maxlength="1000"/>
                </div> -->
                <div class="p-field p-col-12">
                  <label for="product_link">Link Thông tin sản phẩm</label>
                  <InputText  id="product_link" type="text" v-model="product_link"/>
                </div>
                <div class="p-field p-col-12">
                  <label for="desc_product_advantages">Ưu điểm nổi bật</label>
                  <!-- <ckeditor :editor="editor" tag-name="textarea"  v-model="desc_product_advantages"></ckeditor> -->
                  <ckeditor v-model="desc_product_advantages" :config="editorConfig"></ckeditor>
                  <!-- <Textarea  id="desc_product_advantages" rows="5"  v-model="desc_product_advantages"/> -->
                </div>
                <div class="p-field p-col-12">
                  <label for="desc_product_application">Ứng dụng sản phẩm</label>
                  <ckeditor v-model="desc_product_application" :config="editorConfig"></ckeditor>
                  <!-- <Textarea  id="desc_product_application" rows="5"  v-model="desc_product_application"/> -->
                </div>
              </div>
            </TabPanel>
            <TabPanel :key="'2'" @click="click_tab_menu(2)" :active="active_tab.tab_2"  header="Gói dịch vụ" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 box_add_service_park">
                  <div class="p-field p-col-12 p-md-6 service_park_child">
                    <div class="p-col-12 item_add_service_park">
                      <!--<label for="name">Danh sách vật tư - dịch vụ sửa chữa<span class="error">*</span></label>-->
                      <form v-on:submit.prevent="$myConstants.noop()"><!--v-on:submit.prevent="noop"-->
                        <div class="p-fluid p-formgrid p-grid box_add_option" style="">
                          <div class="box_input" style="">
                            <div class="p-field box_title" style="">
                              <label class="title_input" style="">Gói dịch vụ</label>
                              <!--<a  href="#"><label class="add_service_supplies" style="">+ Tạo mới vật tư - dịch vụ</label></a>-->
                            </div>
                            <Dropdown class="width-300" :filter="true" v-model="selected_service_park"
                                      :options="list_sertvice_part" optionLabel="label" placeholder="Chọn gói dịch vụ"/>
                            <!--<Dropdown style="height: 30px" inputId="unit" v-model="city" :options="list_unit" optionLabel="label"  optionValue="value" placeholder="Chọn đơn vị tính"/>-->
                          </div>
                          <button class="add_btn_data" @click="add_model_service_park()" >
                            <img class="style_icon_add" style="" src="../../../../public/assets/images/playlist_add_u605.png"/>
                            <span class="style_text" style="">Thêm</span>
                          </button>
                        </div>
                      </form>
                    </div>
                    <small style="padding-left: 15px" v-if="validationErrors && validationErrors['list_service_park']"
                           class="p-invalid">{{ validationErrors['list_service_park'] }}</small>
                  </div>
                </div>
                <div class="p-field p-col-12">
                  <div class="p-field p-col-12 p-md-12" >
                    <div class="p-col-12">
                      Danh sách gói dịch vụ áp dụng cho model sản phẩm
                    </div>
                    <div class="p-col-12" v-if="obj_service_park.dataModel != null">
                      <BaseCommonList
                          :countCheckBox="true"
                          :labelHeaderAction="'Thao tác'"
                          :key="obj_service_park.componentKey"
                          :listData="obj_service_park.listData"
                          :model="obj_service_park.dataModel"
                          :filterDefault="obj_service_park.filters"
                          v-on:action-click="onActionClickedServicePark"
                          :actions="getRowActionsServicePark()"
                          :pagination="true"
                      ></BaseCommonList>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel :key="'3'" @click="click_tab_menu(3)" :active="active_tab.tab_3"  header="Bảo trì định kỳ" >
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-md-6">
                  <div class="p-field p-col-12">
                    <div class="p-col-8">
                      <label >Áp dụng bảo trì định kỳ <span class="error">*</span></label>
                      <Dropdown  v-model="is_maintenance" :options="$dataCommon.LIST_APPLY_MAINTENANCE" optionLabel="name"  optionValue="value" />
                    </div>
                  </div>
                </div>
                <div class=" p-md-6" v-if="is_maintenance == 1">
                  <div class="p-field p-col-12">
                    <div class="p-col-8 p-offset-4">
                      <label >Loại bảo trì <span class="error">*</span></label>
                      <Dropdown  v-model="type_maintenance" :options="$dataCommon.LIST_TYPE_MAINTENANCE" optionLabel="name" optionValue="value" placeholder="Chọn loại bảo trì"/>
                      <small v-if="validationErrors && validationErrors['type_maintenance']"
                             class="p-invalid" >{{validationErrors['type_maintenance']}}</small>
                    </div>
                  </div>
                </div>
                <div class=" p-md-12" v-if="is_maintenance == 1">
                  <div class="p-field p-col-12 table_maintenance">
                    <DataTable
                        dataKey="id"
                        class="p-datatable-responsive "
                        :scrollable="(object_maintenance.scrollHeight !== '' ? true : false) "
                        :scrollHeight="object_maintenance.scrollHeight"
                        :autoLayout="true"
                        :value="object_maintenance.list_data"

                    ><!--responsiveLayout="scroll"-->
                      <Column
                          :bodyStyle="'width: 110px;'"
                          :headerStyle="'width: 110px;'"
                          :headerClass="object_maintenance.headerClass"
                          field="parts_number" header="Đợt bảo trì">
                        <template #body="slotProps">
                          <div >
                            Đợt {{slotProps.data.parts_number}}
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 180px;text-align: center;'"
                          :headerStyle="'width: 180px;text-align: center;'"
                          :headerClass="object_maintenance.headerClass"
                          field="time_between_maintenance" header="Khoảng thời gian giữa hai đợt bảo trì">
                        <template #body="slotProps">
                          <div style="width: 100%;">
                            <InputNumber style="width:calc(100% - 56px) " id="minmax-buttons" v-model="slotProps.data.time_between_maintenance" mode="decimal" showButtons :min="0" :max="100" />
                            <span style="margin-left: 6px;width: 50px;">Tháng</span>
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 590;text-align: center;'"
                          :headerStyle="'width: 590px;text-align: center;'"
                          :headerClass="object_maintenance.headerClass"
                          field="list_service_pack_id" header="Gói dịch vụ bảo trì">
                        <template #body="slotProps">
                          <div >
                            <MultiSelect display="chip" style="width: 100%" v-model="slotProps.data.list_service_pack_id" :options="list_service_park_maintenance" :filter="true" optionLabel="label" optionValue="id" />
                          </div>
                        </template>
                      </Column>
                      <Column
                          :bodyStyle="'width: 100px;text-align: center;'"
                          :headerStyle="'width: 100px;text-align: center;'"
                          :headerClass="object_maintenance.headerClass"
                          field="key_random">
                        <template #body="slotProps">
                          <Button
                              type="button"
                              :icon="'pi pi-trash'"
                              :class="'p-button-danger'"
                              v-on:click="delete_maintenance(slotProps)"
                          ></Button>
                        </template>
                        <template #header=""><!--slotProps-->
                          <Button
                              type="button"
                              :icon="'pi pi-plus'"
                              :class="'p-button-add'"
                              v-on:click="add_maintenance"
                          ></Button>
                        </template>
                      </Column>
                      <template #empty>
                        Không có dữ liệu
                      </template>
                    </DataTable>
                  </div>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import templateSerialNumber from '../common/templateSerialNumber'
import DataServices from '@/core/DataServices'
import BaseCommonList from '../common'
import Api from '@/services'
export default {
  components: {
    templateSerialNumber,
    BaseCommonList
  },
  data() {
    return {
      formMode: 'add',
      listData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'product',
      model_code: '',
      name: '',
      category_id: 0,
      productionStatus: 1,
      optionStatus: [{ value: 1, label: 'Đang sản xuất'}, { value: 0, label: 'Ngưng sản xuất'}],
      qr_code_size: 'mau_2',
      qrCodeSizes: [{ value: 'mau_2', label: 'Mẫu 5x3cm'}],
      warranty_time: 0,
      returnable_time: 0,
      returnable_appraisal_time: 0,
      change_time: 0,
      optionsCategories: [],
      description: '',
      productImages: [],
      productQRCode: '',
      productID : 0,
      title: '',
      note: '',
      hotline: '',
      slug: '',
      product_link:'',
      desc_product_advantages: '',
      desc_product_application: '',
      serialNumber: '12345678912',
      validationErrors: {},
      model_code_exists: false,
      model_name_exists: false,
      slug_exists: false,
      modelData: null,
      is_manually_verification: false,
      disabled: false,
      logoPortal: '',
      titleModel: 'Tạo mới model sản phẩm',
      submitForm: false,
      labelName: 'Tạo',
      link_pdf:"",
      link_youtube:"",
      editorConfig: {
        toolbar: [
          { name: 'document', items: [ 'Source', '-', 'Save', 'NewPage', 'ExportPdf', 'Preview', 'Print', '-', 'Templates' ] },
          { name: 'clipboard', items: [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
          { name: 'editing', items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
          { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
          '/',
          { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ] },
          { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ] },
          { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
          { name: 'insert', items: [ 'Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] },
          '/',
          { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
         
        ]
      },
      obj_service_park:{
        componentKey: 0,
        listData: [],
        listOld: [],
        dataModel: null,
        filters: {},
      },
      list_id_service_park_delete:[],
      list_sertvice_part:[],
      selected_service_park:null,
      is_maintenance:0,
      type_maintenance:null,
      object_maintenance:{
        list_product_service_park_init_id: [],//danh sách id lúc đầu để so sánh để xóa
        list_product_service_park: [],
        list_data: [],
        list_service_park: [],
        selected_service_park: null,
        service_unit_map_data: null,
        scrollHeight: '', // chiều cao của trang danh sách
        service_total_price_service:0,
        service_total_discount:0,
        service_total_money_discount:0,
        service_tax:0,
        service_money_tax:0,
        service_total_price_payment:0,
        headerClass:'style_header',
        footerClass:'style_footer',
      },
      list_service_park_maintenance: [],
      active_tab: {
        tab_0:true,
        tab_1:false,
        tab_2:false,
        tab_3:false,
      },
      data_old_maintenance:[],
      display_page:true,
      componentKeyQRcode:0
    }
  },
  async mounted () {
    var vm = this;
    // if (this.checkVisible('add') || this.checkVisible('edit')) {
      await this.categories();
      await this.getSettings();
      this.dataModel = DataServices.getModel(this.modelName);
      if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
        if (!vm.$myConstants.checkRoleGroup('product', 'edit')){
          vm.display_page = false;
        }
        this.titleModel = 'Chỉnh sửa model sản phẩm';
        this.formMode = 'edit';
        await this.getData(Number(this.$route.params.id));
      }else {
        if (!vm.$myConstants.checkRoleGroup('product', 'add')){
          vm.display_page = false;
        }
      }
    //load data
    this.load_data();

    // } else {
    //   this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
    //   this.$store.commit('setLoading', true);
    //   this.$router.go(-1);
    // }
  },
  async created() {

  },
  methods: {
    changeModelCode(){
      this.componentKeyQRcode++;
      console.log("this.componentKeyQRcode",this.componentKeyQRcode)
    },
    checkVisible(action, groupName = 'product') {
      if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null && 
			this.$store.getters.fullname.user_type != undefined && this.$store.getters.fullname.user_type == 3) return true;
			else {
				var permission = this.$store.getters.permission;
				if (permission != null) {
					var returnData = permission.filter(a => a.group == groupName && a.action == action);
					return returnData && Object.keys(returnData).length;
				}
        return false;
			}
    },
    async getSettings() {
      var variables = {
        where_key: {
          key: {'_in': ['QR_SERIAL_NUMBER_TITLE', 'QR_SERIAL_NUMBER_NOTE', 'QR_SERIAL_NUMBER_HOTLINE']}
        },
        orderBy: {
          key: 'desc'
        }
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), 'fields' : 'key value'});
      if (data != undefined && data != null && data[Object.keys(data)].length) {
        var lists = data[Object.keys(data)];
        var objTitle = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_TITLE');
        if (objTitle && Object.keys(objTitle).length) {
          this.title = objTitle[0].value;
        }
        var objNote = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_NOTE');
        if (objNote && Object.keys(objNote).length) {
          this.note = objNote[0].value;
        }
        var objHotline = lists.filter(a => a.key == 'QR_SERIAL_NUMBER_HOTLINE');
        if (objHotline && Object.keys(objHotline).length) {
          this.hotline = objHotline[0].value;
        }
      }
    },
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      console.log("datadata:",data);
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        var model = list[0];
        this.modelData = model;
        this.productID = model.id;
        this.labelName = 'Lưu';
        if(model.model_code != undefined) this.model_code = model.model_code;
        if(model.link_pdf != undefined) this.link_pdf = model.link_pdf;
        if(model.link_youtube != undefined) this.link_youtube = model.link_youtube;
        if(model.category_id != undefined) this.category_id = model.category_id;
        if(model.description != undefined) this.description = model.description;
        if(model.name != undefined) this.name = model.name;
        if(model.production_status != undefined) this.productionStatus = model.production_status;
        if(model.returnable_time != undefined) this.returnable_time = model.returnable_time;
        if(model.change_time != undefined) this.change_time = model.change_time;
        if(model.returnable_appraisal_time != undefined) this.returnable_appraisal_time = model.returnable_appraisal_time;
        
        if(model.warranty_time != undefined) this.warranty_time = model.warranty_time;
        if(model.qr_code_size != undefined) this.qr_code_size = model.qr_code_size;
        this.is_manually_verification = model.is_manually_verification;
        if(model.desc_product_advantages != undefined) this.desc_product_advantages = model.desc_product_advantages;
        if(model.desc_product_application  != undefined) this.desc_product_application  = model.desc_product_application;
        if(model.slug  != undefined) this.slug  = model.slug;
        if(!this.$myConstants.isEmpty(model.product_link)) this.product_link  = model.product_link;
        this.is_maintenance = (!this.$myConstants.isEmpty(model.is_maintenance)) ? model.is_maintenance:0;
        this.type_maintenance = (!this.$myConstants.isEmpty(model.type_maintenance)) ? model.type_maintenance:0;

        if(model.thumbnails != undefined ) {
          this.productImages.push({source: '', objectURL: (model.thumbnails.external_path != undefined  && model.thumbnails.external_path != null ? model.thumbnails.external_path : (model.thumbnails.local_path != undefined && model.thumbnails.local_path != null ? model.thumbnails.cdn_path + '' +model.thumbnails.local_path : ''))});
        } else {
          this.logoPortal = window.origin + '/assets/images/logo_HK-01.png'
        }
        if(model.product_serial_number_aggregate != undefined && model.product_serial_number_aggregate !== null && model.product_serial_number_aggregate.aggregate != undefined && model.product_serial_number_aggregate.aggregate != null ) {
          this.disabled = model.product_serial_number_aggregate.aggregate.count > 0;
        }
        this.componentKey++;
        this.componentKeyQRcode++;
      }
    },
    backList() {
       this.$router.push({path: '/admin/product'});
    },
    async categories() {
      var variables = {
        where_key: {
          status: {'_in': [1] }
        }
      }
      var data = await DataServices.getList('categories', {"variables": JSON.stringify(variables), "fields": "id,name"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          this.optionsCategories.push({label: item.name, value: item.id});
        }
      }
    },
    openFile() {
      this.$refs.files.click();
    },
    chooseFile($event) {
      var checkFile = false;
      var arrFiles = [];
      this.productImages = [];
      var fileSelects = $event.target.files || $event.dataTransfer.files;
      if (!fileSelects.length)
        return;
      for (let index = 0; index < fileSelects.length; index++) {
        const file = fileSelects[index];
        if (this.$myConstants.isImage(file.type)) {
          file.source = file;
          file.objectURL = window.URL.createObjectURL(file);
          arrFiles.push(file);
        } else {
          checkFile = true;
          break;
        }
      }
      if (checkFile) {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Sai định dạng file', life: 3000 })
      } else {
        this.productImages = this.productImages.concat.apply(this.productImages, arrFiles);
      }
    },
    async changeCategories() {
      if (this.category_id !== undefined && this.category_id > 0) {
        var where = {id: {'_eq': this.category_id } };
        var data = await DataServices.getList('categories', {"fields": "is_manually_verification", "variables": JSON.stringify({where_key: where})});
         var returning = data[Object.keys(data)];
        if ( returning && returning[0].is_manually_verification != undefined) {
          this.is_manually_verification =  returning[0].is_manually_verification > 0 ? true : false;
        }
      }
    },
    async checkModelCode() {
      this.model_code = this.model_code.trim();
      if (this.model_code !== undefined && this.model_code !== "") {
        var where = { model_code: {'_ilike': this.model_code} }
        if (this.productID > 0) where = Object.assign(where, {id: {'_neq': this.productID}})
        var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    async checkModelName() {
      this.name = this.name.trim();
      if (this.name !== undefined && this.name !== "") {
        var where = { name: {'_ilike': this.name} }
        if (this.productID > 0) where = Object.assign(where, {id: {'_neq': this.productID}})
        var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    // async checkSlug() {
    //   this.name = this.name.trim();
    //   if (this.name !== undefined && this.name !== "") {
    //     this.slug = this.$myConstants.cleanAccents(this.name).replace(/[^a-zA-Z0-9]/g, "_");
    //     var where = { slug: {'_ilike': this.slug} }
    //     if (this.productID > 0) where = Object.assign(where, {id: {'_neq': this.productID}})
    //     var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
    //     return data && data[Object.keys(data)].length > 0
    //   }
    // },
    async validationData() {
      this.validationErrors = {};
      var tab_active = [];
      if (this.model_code === undefined || this.model_code == ''){
        tab_active.push(0);
        this.validationErrors['model_code'] = 'Nhập model sản phẩm';
      }else {
        if(this.model_code.length > 26){
          tab_active.push(0);
          this.validationErrors['model_code'] = 'Nhập tối đa 26 ký tự';
        }/*else {
          if(this.model_code.search("-") == -1){
            tab_active.push(0);
            this.validationErrors['model_code'] = 'Nhập dấu gạch ngang cho Model sản phẩm';
          }
        }*/
      }
      if (this.name === undefined || this.name == ''){
        tab_active.push(0);
        this.validationErrors['name'] = 'Nhập tên sản phẩm';
      }
      if(this.category_id == undefined || this.category_id == 0){
        tab_active.push(0);
        this.validationErrors['category_id'] = 'Chọn nhóm sản phẩm';
      }
      if(this.qr_code_size == undefined || this.qr_code_size == ''){
        tab_active.push(0);
        this.validationErrors['qr_code_size'] = 'Chọn mẫu QR Code';
      }
      if(this.warranty_time == undefined || this.warranty_time.length == 0 || this.warranty_time == 0){
        tab_active.push(0);
        this.validationErrors['warranty_time'] = 'Nhập thời hạn bảo hành';
      }
      if (!this.$myConstants.isEmpty(this.link_pdf)){
        if (!this.$myConstants.isValidHttpUrl(this.link_pdf)){
          this.validationErrors['link_pdf'] = 'Vui lòng nhập đúng định dạng';
        }
      }
      if (!this.$myConstants.isEmpty(this.link_youtube)){
        if (!this.$myConstants.isValidHttpUrl(this.link_youtube)) {
          this.validationErrors['link_youtube'] = 'Vui lòng nhập đúng định dạng';
        }
      }
      this.model_code_exists = await this.checkModelCode();
      if (this.model_code_exists){
        tab_active.push(0);
      }
      this.model_name_exists = await this.checkModelName();
      if (this.model_name_exists){
        tab_active.push(0);
      }
      // this.slug_exists = await this.checkSlug();
      if (this.is_maintenance == 1){
        if (this.$myConstants.isEmpty(this.type_maintenance)){
          tab_active.push(3);
          this.validationErrors['type_maintenance'] = 'Chọn loại bảo trì';
        }else {
          if (this.object_maintenance.list_data.length < 1){
            tab_active.push(3);
            if (Math.min(...tab_active) == 3){
              this.$toast.add({
                severity: 'error',
                summary: 'Thông báo',
                detail: 'Vui lòng thêm thông tin kế hoạch bảo trì định kỳ.',
                life: 3000
              });
            }
            this.validationErrors['object_maintenance_list_data'] = 'Dừng validate';
          }else {
            var list_maintenance = this.object_maintenance.list_data;
            for (var i=0;i<list_maintenance.length;i++){
              if (this.$myConstants.isEmpty(list_maintenance[i].time_between_maintenance) || list_maintenance[i].list_service_pack_id <1){
                tab_active.push(3);
                if (Math.min(...tab_active) == 3) {
                  this.$toast.add({
                    severity: 'error',
                    summary: 'Thông báo',
                    detail: 'Vui lòng nhập đủ thông tin kế hoạch bảo trì định kỳ.',
                    life: 3000
                  });
                }
                this.validationErrors['object_maintenance_list_data'] = 'Dừng validate';
                break;
              }else {
                if (parseFloat(list_maintenance[i].time_between_maintenance) < 1){
                  tab_active.push(3);
                  if (Math.min(...tab_active) == 3) {
                    this.$toast.add({
                      severity: 'error',
                      summary: 'Thông báo',
                      detail: 'Vui lòng nhập Khoảng thời gian giữa hai đợt bảo trì lớn hơn 0.',
                      life: 3000
                    });
                  }
                  this.validationErrors['object_maintenance_list_data'] = 'Dừng validate';
                  break;
                }
              }
            }
          }
        }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        if (tab_active.length >0){
          //lấy tab nhỏ nhất để active
          var min_tab = Math.min(...tab_active);
          //console.log("min_tab:",min_tab)
          this.active_tab_menu(min_tab)
        }
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }

    },
    async saveData() {
      this.submitForm = true;
      await this.validationData();
      if (!this.model_code_exists && !this.model_name_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        // if (this.slug_exists)  this.slug += '-' + this.$myConstants.currentDate();
        var slug_data = this.$myConstants.ChangeToSlug(this.name);
        var params = { 
          'name': this.name,
          'slug': slug_data+((new Date()).getTime()).toString(),//Gán tạm update lại sau
          'product_link':this.product_link,
          'model_code': this.model_code,
          'description': this.description,
          'warranty_time': this.warranty_time,
          'warranty_unit': 'month',
          'change_time': this.change_time,
          'change_unit': 'day',
          'returnable_time': this.returnable_time,
          'returnable_appraisal_time': this.returnable_appraisal_time,
          'returnable_unit': 'day',
          'category_id': this.category_id,
          'qr_code_size': this.qr_code_size,
          'production_status': this.productionStatus,
          'is_manually_verification': this.is_manually_verification,
          'desc_product_advantages': this.desc_product_advantages,
          'desc_product_application': this.desc_product_application,
          'is_maintenance': this.is_maintenance,
          'type_maintenance': this.type_maintenance,
          'link_pdf': this.link_pdf,
          'link_youtube': this.link_youtube,
          'modified_date': this.$myConstants.currentDate(),
        }
        
        if (this.modelData != null && Object.keys(this.modelData).length) {
          params.slug = slug_data+'-'+this.productID;
          await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.productID }}})});
          this.updateAdditionalProduct();
          this.uploadImages(params);
        } else {
          params = Object.assign(params, { 'status': 1 })
          params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
          //thêm gói dịch vụ
          var dataInsertServicePark = [];
          for (var s=0;s<this.obj_service_park.listData.length;s++){
            if (this.obj_service_park.listData[s].apply_all_model != 1){
              var data_p_product = {
                service_pack_id: this.obj_service_park.listData[s].id,
                status: 1,
                created_date: this.$myConstants.currentDate(),
                modified_date: this.$myConstants.currentDate(),
              }
              dataInsertServicePark.push(data_p_product);
            }
          }
          if (dataInsertServicePark.length > 0){
            params.arr_service_pack_product = {data: dataInsertServicePark};
          }
          //thêm bảo trì định kỳ
          var dataInsertMaintenance = [];
          var list_maintenance = this.object_maintenance.list_data;
          for (var m=0;m<list_maintenance.length;m++){
            var itemMaintenance = {
              parts_number: list_maintenance[m].parts_number,
              time_between_maintenance : list_maintenance[m].time_between_maintenance,
              list_service_pack_id : JSON.stringify(list_maintenance[m].list_service_pack_id),
              status: 1,
              modifier_id: this.$store.getters.fullname.id,
              modified_date: this.$myConstants.currentDate(),
            };
            dataInsertMaintenance.push(itemMaintenance);
          }
          if (dataInsertMaintenance.length > 0){
            params.arr_product_maintenance = {data: dataInsertMaintenance};
          }
          var dataProduct = await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
          var recordProduct = dataProduct[Object.keys(dataProduct)];
          if (recordProduct != null && Object.keys(recordProduct).length) {
            if (recordProduct.affected_rows) {
              var item = recordProduct.returning[0];
              this.productID = item.id;
              var data_update_additional = {
                'slug': slug_data+'-'+this.productID
              };
              DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: data_update_additional, where_key: { id: {'_eq': this.productID }}})});
              this.uploadImages(params);
            }
          }
        }
      } else this.submitForm = false;
    },
    async updateAdditionalProduct() {
      if (this.formMode == 'edit'){
        var id_product = this.$route.params.id;
        if (this.list_id_service_park_delete.length > 0){
          //bật cờ delete sản phẩm ra khỏi gói dịch vụ
          var params_delete_service_park_product = {
            status: 0
          }
          DataServices.updateData('service_pack_product', {"variables": JSON.stringify({data_update: params_delete_service_park_product, where_key: { product_id: {_eq: id_product},status: {_eq: 1},service_pack_id: {'_in': this.list_id_service_park_delete}}})});
        }
        //thêm mới những gói dịch vụ
        var dataInsertServiceProduct = [];
        if (this.obj_service_park.listData.length > 0){
          for (var i=0;i<this.obj_service_park.listData.length;i++){
            if (this.$myConstants.isEmpty(this.obj_service_park.listData[i].old)){
              if (this.obj_service_park.listData[i].apply_all_model != 1){
                var itemServiceProduct = {
                  service_pack_id: this.obj_service_park.listData[i].id,
                  product_id: id_product,
                  status: 1,
                  created_date: this.$myConstants.currentDate(),
                  modified_date: this.$myConstants.currentDate(),
                };
                dataInsertServiceProduct.push(itemServiceProduct);
              }
            }
          }
        }
        if (dataInsertServiceProduct.length > 0){
          DataServices.insertData('service_pack_product', {"variables": JSON.stringify({objects: dataInsertServiceProduct})});
        }
        //Mỗi lần update đều xóa đợt bảo trì cũ
        var params_delete_product_maintenance = {
          status: 0
        }
        await DataServices.updateData('product_maintenance', {"variables": JSON.stringify({data_update: params_delete_product_maintenance, where_key: { product_id: {_eq: id_product},status: {_eq: 1}}})});
        if (this.is_maintenance == 1){
            //thêm mới bảo trì
          var dataInsertMaintenance = [];
          var list_maintenance = this.object_maintenance.list_data;
          for (var m=0;m<list_maintenance.length;m++){
            var itemMaintenance = {
              product_id: id_product,
              parts_number: list_maintenance[m].parts_number,
              time_between_maintenance : list_maintenance[m].time_between_maintenance,
              list_service_pack_id : JSON.stringify(list_maintenance[m].list_service_pack_id),
              status: 1,
              modifier_id: this.$store.getters.fullname.id,
              modified_date: this.$myConstants.currentDate(),
            };
            dataInsertMaintenance.push(itemMaintenance);
          }
          if (dataInsertMaintenance.length > 0){
            DataServices.insertData('product_maintenance', {"variables": JSON.stringify({objects: dataInsertMaintenance})});
          }
        }

      }
    },
    async addHistoryModelProductImport(newProduct) {
      var productID = this.productID;
      var userID = this.$store.getters.fullname.id;
      var organizationID = (this.$store.getters.fullname.organization_account != undefined && this.$store.getters.fullname.organization_account != null && this.$store.getters.fullname.organization_account.organization_id != undefined) ? this.$store.getters.fullname.organization_account.organization_id : 0;
      var oldProduct = this.modelData;
      //lưu thêm dữ liệu thêm mới của bảo trì
      if (this.is_maintenance == 1){
        var list_data_maintenance = this.object_maintenance.list_data;
        for (var i=0; i<list_data_maintenance.length;i++){
          var arr_data_service_park = [];
          var service_park_check =await this.service_park_product_by_arr_service_park(productID,list_data_maintenance[i].list_service_pack_id);
          for (var s=0;s<service_park_check.length;s++){
            arr_data_service_park.push(service_park_check[s])
          }
          list_data_maintenance[i].arr_data_service_park = arr_data_service_park;
        }
        newProduct.maintenance = list_data_maintenance
      }
      var params = {product_id: productID, modifier_id: userID, organization_id: organizationID, modified_date: this.$myConstants.currentDate(), created_date: this.$myConstants.currentDate(), status: 1, old_value: oldProduct, new_value: newProduct};
      await DataServices.insertData('product_changed_log', {"variables": JSON.stringify({objects: params})});
    },
    async uploadImages(params) {
      var vm = this;
      if (vm.productImages.length > 0) {
        var checkUpload = vm.productImages.filter(a => a.source != '');
        if (checkUpload && Object.keys(checkUpload).length) {
          var file = vm.productImages[0];
          var name = file.name;
          let formData = new FormData();
          formData.append('file', file)
          await Api.post('/common/upload-s3', formData)
          .then(async (response) => {
            vm.updateImageProduct(params, name, response.data.data);
          })
          .catch(async () => {this.$store.commit('setLoading', false);});
        } else {
          await this.writeProductLog(params);
        }
      } else {
        await this.writeProductLog(params);
      }
    },
    async writeProductLog(params) {
      var newProduct = params;
      if (this.modelData != null && this.modelData.thumbnails != undefined && this.modelData.thumbnails != null) {
        newProduct = Object.assign(newProduct, {thumbnails: {
          local_path: this.modelData.thumbnails.path,
          cdn_path: this.modelData.thumbnails.cdn,
          external_path: this.modelData.thumbnails.external_path
        }}); 
      }

      await this.addHistoryModelProductImport(newProduct);
      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      setTimeout(() => {
        this.$router.push({path: '/admin/product'});
      }, 500);
    },
    async updateImageProduct(newProduct, name, payload) {
      var params = {name: name, local_path: payload.path, is_cdn_synced: true, cdn_path: payload.cdn, media_type: payload.media_type, file_size: payload.file_size, created_date: this.$myConstants.currentDate(), status: 1};
      var dataInsert = await DataServices.insertData('media', {"variables": JSON.stringify({objects: params})});
      var returning = dataInsert[Object.keys(dataInsert)];
      if (returning && Object.keys(returning).length) {
        if (returning.affected_rows) {
          var thumbnail_id = returning.returning[0].id;
          var paramsThumbnail = {
            'thumbnail_id': thumbnail_id
          };
          await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: paramsThumbnail, where_key: { id: {'_eq': this.productID }}})});
          newProduct = Object.assign(newProduct, {thumbnails: {
            local_path: payload.path,  cdn_path: payload.cdn
          }}); 
        }
      }
      await this.addHistoryModelProductImport(newProduct);
      this.$store.commit('setLoading', false);
      this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
      setTimeout(() => {
        this.$router.push({path: '/admin/product'});
      }, 500);
    },
    async load_data() {
      var vm = this;
      this.obj_service_park.dataModel = DataServices.getModel('service_pack_from_product');
      if (this.formMode == 'edit') {
        var id_product = this.$route.params.id;

        var whereDefault_ = {status: {'_in': [1]}};
        var whereAttach = {};
        whereAttach._or = [];
        whereAttach._or.push({apply_all_model: {_eq: "1"}});//điều kiện tất cả các model sản phẩm
        if (!this.$myConstants.isEmpty(id_product)){
          whereAttach._or.push({arr_service_pack_product: {product_id: {_eq: id_product}, status: {_eq: "1"}}});//hoặc gói dịch vụ thuộc sp
        }
        if (whereAttach){
          for (const [key, value] of Object.entries(whereAttach)) {
            whereDefault_[key] = value;
          }
        }
        var order_by_service = [
          {apply_all_model: 'asc'},
          {id: 'desc'}
        ];
        this.$coreService.get_service_park_all(whereDefault_,order_by_service).then(async (data) => {
        //DataServices.getList('service_pack_product', {"variables": JSON.stringify(variables_service_park)}).then(async (data) => {
          //var list = data[Object.keys(data)];
          var list = data;
          //Lấy list id cũ để kiểm tra update
          var list_data = [];
          var list_id_model = [];
          for (var i = 0; i < list.length; i++) {
            var data_obj = list[i];
            if (data_obj.apply_all_model != 1){
              list_id_model.push(data_obj.id);
            }
            //var data_obj = list[i].obj_service_pack;
            data_obj.old = true;
            list_data.push(data_obj);
          }

          var variables_service_park = {
            where_key: {
              obj_service_pack: {status: {_eq: 1}},
              product_id: {_eq: id_product},
              service_pack_id: {'_in': list_id_model},
              status: {_eq: 1}
            },
            orderBy: {"id": "desc"}
          }
          var service_pack_product =await DataServices.getList('service_pack_product', {"variables": JSON.stringify(variables_service_park)});
          var list_service_pack_product = service_pack_product[Object.keys(service_pack_product)];
          var data_map_sort = {};
          for (var k=0;k<list_service_pack_product.length;k++){
            data_map_sort["k_"+list_service_pack_product[k].service_pack_id] = list_service_pack_product[k].id
          }
          //console.log("data_map_sort:",data_map_sort)
          for (var m=0;m<list_data.length;m++){
            list_data[m].sort_product = 0;
            if (data_map_sort["k_"+list_data[m].id]){
              list_data[m].sort_product = parseFloat(data_map_sort["k_"+list_data[m].id]);
            }
          }
          if (list_data.length > 0){
            list_data.sort((a,b)=> (a.apply_all_model - b.apply_all_model ||  b.sort_product - a.sort_product || b.id - a.id ));
          }
            vm.obj_service_park.listData = list_data;
          vm.obj_service_park.componentKey++;
          //load list service park
          var whereDefault = {status: {'_in': [1]},apply_all_model: {_eq: 0},_not: {arr_service_pack_product: {product_id: {_eq: id_product}, status: {_eq: "1"}}}};
          this.load_list_service_park(whereDefault);
          this.load_service_park_maintenance();
        }).catch(async () => {
          vm.obj_service_park.listData = [];
          vm.obj_service_park.componentKey++;
        });
        //load danh sách bảo trì
        //load danh sách bảo trì
        if (this.is_maintenance == 1){
          var variables_product_maintenance = {
            where_key: {
              product_id: {_eq: id_product},
              status: {_eq: 1}
            },
            orderBy: {"parts_number": "asc"}
          }
          DataServices.getList('product_maintenance', {"variables": JSON.stringify(variables_product_maintenance)}).then(async (data) => {
            var list = data[Object.keys(data)];
            //Lấy list id cũ để kiểm tra update
            var list_data = [];
            for (var i = 0; i < list.length; i++) {
              var data_add = {
                parts_number:list[i].parts_number,
                time_between_maintenance:list[i].time_between_maintenance,
                //list_service_pack_id:(!vm.$myConstants.isEmpty(list[i].list_service_pack_id)) ? JSON.parse(list[i].list_service_pack_id):[],
                key_random:(new Date()).getTime(),
              };
              var arr_service_park_id = (!vm.$myConstants.isEmpty(list[i].list_service_pack_id)) ? JSON.parse(list[i].list_service_pack_id):[];
              var arr_res_service_park_id = [];
              //lưu để lưu lại lịch sử
              var arr_data_service_park = [];
              //check lại những dịch vụ đó có bị xóa ko!
              var service_park_check =await vm.service_park_product_by_arr_service_park(id_product,arr_service_park_id);
              for (var s=0;s<service_park_check.length;s++){
                arr_res_service_park_id.push(service_park_check[s].id);
                arr_data_service_park.push(service_park_check[s])
              }
              data_add.list_service_pack_id = arr_res_service_park_id;
              data_add.arr_data_service_park = arr_data_service_park;
              list_data.push(data_add);
              //vm.listModelProduct.listOld.push(list[i].obj_product.id);
            }
            vm.object_maintenance.list_data = list_data;
            //add data old
            vm.modelData.maintenance = vm.$myConstants.convertJsonObject(list_data);
          }).catch(async () => {
            vm.object_maintenance.list_data = [];
          });
        }
      }else {
        var whereDefault_add = {status: {'_in': [1]}};
        var whereAttach_add = {};
        whereAttach_add._or = [];
        whereAttach_add._or.push({apply_all_model: {_eq: "1"}});//điều kiện tất cả các model sản phẩm
        /*if (!this.$myConstants.isEmpty(id_product)){
          whereAttach_add._or.push({arr_service_pack_product: {product_id: {_eq: id_product}, status: {_eq: "1"}}});//hoặc gói dịch vụ thuộc sp
        }*/
        if (whereAttach_add){
          for (const [key, value] of Object.entries(whereAttach_add)) {
            whereDefault_add[key] = value;
          }
        }
        var service_park_ =await  this.$coreService.get_service_park_all(whereDefault_add);
        vm.obj_service_park.listData = service_park_;
        vm.obj_service_park.componentKey++;
        //load list service park
        var whereDefault = {status: {'_in': [1]},apply_all_model: {_eq: 0}};
        this.load_list_service_park(whereDefault);
        this.load_service_park_maintenance();
      }

    },
   async service_park_product_by_arr_service_park(id_product,arr_service_park_id){
      /*var variables_service_park_check = {
        where_key: {
          service_pack_id: {_in: arr_service_park_id},
          product_id: {_eq: id_product},
          status: {_eq: 1}
        },
        orderBy: {"id": "desc"}
      }
      var service_park_data = await DataServices.getListData('service_pack_product', {"variables": JSON.stringify(variables_service_park_check)});
*/

     var whereDefault_ = {status: {'_in': [1]},id: {_in: arr_service_park_id}};
     var whereAttach = {};
     whereAttach._or = [];
     whereAttach._or.push({apply_all_model: {_eq: "1"}});//điều kiện tất cả các model sản phẩm
     if (!this.$myConstants.isEmpty(id_product)){
       whereAttach._or.push({arr_service_pack_product: {product_id: {_eq: id_product}, status: {_eq: "1"}}});//hoặc gói dịch vụ thuộc sp
     }
     if (whereAttach){
       for (const [key, value] of Object.entries(whereAttach)) {
         whereDefault_[key] = value;
       }
     }
     var order_by_service = [
       {apply_all_model: 'asc'},
       {id: 'desc'}
     ];
     var service_park_data = await this.$coreService.get_service_park_all(whereDefault_,order_by_service);

      return service_park_data;
    },
    load_list_service_park(whereDefault){
      var vm = this;
      vm.$coreService.get_service_park_all(whereDefault).then(async (data_list) => {
        if (data_list.length > 0){
          for (var i=0;i<data_list.length;i++){
            var code = (!vm.$myConstants.isEmpty(data_list[i].code)) ? data_list[i].code:'';
            var name = (!vm.$myConstants.isEmpty(data_list[i].name)) ? data_list[i].name:'';
            data_list[i].label = code+' - '+name;
          }
        }
        vm.list_sertvice_part = data_list;
      }).catch(async () => {
        vm.list_sertvice_part = [];
      });
    },
    load_service_park_maintenance(){
      var vm = this;
      var whereDefault = {status: {'_in': [1]}};
      whereDefault._or = [];
      //whereDefault._or.push({apply_all_model: {_eq: "1"}});//điều kiện tất cả các model sản phẩm
      var list_id_service_park = [];
      //lấy service park được thêm
      if (this.obj_service_park.listData.length > 0){
        for (var s = 0;s<this.obj_service_park.listData.length;s++){
          list_id_service_park.push(this.obj_service_park.listData[s].id);
        }
        console.log("list_id_service_park:",list_id_service_park)
        whereDefault._or.push({id: {'_in': list_id_service_park}});
      }else {
        //ko tồn tại gói dịch vụ trả về mảng rỗng
        vm.list_service_park_maintenance = [];
        return false;
      }
      console.log("whereDefaultwhereDefault:",whereDefault)
      vm.$coreService.get_service_park_all(whereDefault).then(async (data_list) => {
        console.log("data_listdata_list:",data_list)
        if (data_list.length > 0){
          for (var i=0;i<data_list.length;i++){
            var code = (!vm.$myConstants.isEmpty(data_list[i].code)) ? data_list[i].code:'';
            var name = (!vm.$myConstants.isEmpty(data_list[i].name)) ? data_list[i].name:'';
            data_list[i].label = " "+code+' - '+name;
          }
        }
        vm.list_service_park_maintenance = data_list;
      }).catch(async (errr) => {
        console.log("errr",errr)
        vm.list_service_park_maintenance = [];
      });
    },
    onActionClickedServicePark(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30))
          }
          break;
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.modelEdit = data.data;
            this.displayDialog = true
            this.editDialogKey = Math.floor(Math.random() * (30));
          }
          break;
        case 'delete':
          var id_delete = data.data.id;
          //check gói dịch vụ này đã được thêm bên tab bảo trì chưa
          if (this.object_maintenance.list_data.length > 0){
            for (var m=0;m<this.object_maintenance.list_data.length;m++){
              var list_service_pack_id = this.object_maintenance.list_data[m].list_service_pack_id;
              if (list_service_pack_id.indexOf(id_delete) > -1){
                this.$toast.add({
                  severity: 'error',
                  summary: 'Thông báo',
                  detail: 'Gói dịch vụ đang được áp dụng cho các đợt bảo trì của sản phẩm, vui lòng kiểm tra lại trước khi xóa.',
                  life: 3000
                });
                return false;
              }
            }
          }
          if (!this.$myConstants.isEmpty(data.data.old)){
            this.list_id_service_park_delete.push(id_delete);
          }
          var key_delete = null
          var list_id = [];
          for (var i = 0; i < this.obj_service_park.listData.length; i++) {
            if (parseFloat(id_delete) == parseFloat(this.obj_service_park.listData[i].id)) {
              key_delete = i;
            } else {
              list_id.push(this.obj_service_park.listData[i].id);
            }
          }
          if (!this.$myConstants.isEmpty(key_delete)) {
            this.obj_service_park.listData.splice(key_delete, 1);
          }
          var whereDefault = {status: {'_in': [1]},apply_all_model: {_eq: 0},id:{'_nin': list_id}};
          this.load_list_service_park(whereDefault);
          //load sevice park tab bảo trì
          this.load_service_park_maintenance();
          this.obj_service_park.componentKey++;
          break;
      }
    },
    getRowActionsServicePark() {
      var actions = {}
      //var that = this;
      actions.filter = {name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        //console.log(rowData)
        /*buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }*/
        if (rowData.apply_all_model != 1){
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        }
        return buttons
      }
      return actions
    },
    add_model_service_park() {
      if (!this.selected_service_park) {
        //alert("Vui lòng chọn");
        this.validationErrors['list_service_park'] = 'Vui lòng thêm gói dịch vụ cho sản phẩm';
        this.$forceUpdate();
        return false;
      }
      this.validationErrors['list_service_park'] = '';
      this.obj_service_park.listData.unshift(this.selected_service_park);//push đầu dòng
      this.selected_service_park = null;
      var list_id = [];
      for (var i = 0; i < this.obj_service_park.listData.length; i++) {
        list_id.push(this.obj_service_park.listData[i].id);
      }
      var whereDefault = {status: {'_in': [1]},apply_all_model: {_eq: 0},id:{'_nin': list_id}};
      this.load_list_service_park(whereDefault);
      //load sevice park tab bảo trì
      this.load_service_park_maintenance();
      this.obj_service_park.componentKey++;

    },
    add_maintenance() {
      var data_add = {
        parts_number:(this.object_maintenance.list_data.length+1),
        time_between_maintenance:1,
        list_service_pack_id:[],
        key_random:(new Date()).getTime(),
      };
      this.object_maintenance.list_data.push(data_add);
    },
    delete_maintenance(data) {
      var index = data.index;
      this.object_maintenance.list_data.splice(index, 1);
      for (var i = 0; i < this.object_maintenance.list_data.length; i++) {
        this.object_maintenance.list_data[i].parts_number = i+1;//set laị số đợt
      }
    },
    active_tab_menu(tab) {
      //set tất cả các tab về 0
      for (const [key] of Object.entries(this.active_tab)) {
        this.active_tab[key] = false;
      }
      this.active_tab["tab_" + tab] = true;
    },
    click_tab_menu(data){
      //vì menu ko có data để nên lấy header set về tab
      var header_tab = {
        "Thông tin chung":0,
        "Mô tả sản phẩm":1,
        "Gói dịch vụ":2,
        "Bảo trì định kỳ":3,
      }
      //console.log("tab",data)
      var tab = header_tab[data.tab.header]
      this.active_tab_menu(tab);
    },
  }
}
</script>
<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px; 
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .unit-custom{text-align: right;
    label{margin-bottom: 0; margin-top: 10px;}
  }
  .box-qrcode-product{margin-top: 20px;}
  .box-img-product{margin-top: 40px;}
}
.custom-qr-code { 
  .qr-custom{width: 150px !important; height: 150px !important;}
}

.box_add_option {
  background-color: rgba(242, 242, 242, 1);
  border-radius: 10px;
  margin: 0px;
  padding: 15px;

  .box_input {
    padding: 0px;
    width: calc(100% - 120px);

    .box_title {
      position: relative;
      height: 20px;
      margin-bottom: 2px;
      .title_input {
        font-size: 14px;
        position: absolute;
        left: 0px;
      }

      .add_service_supplies {
        font-size: 14px;
        position: absolute;
        right: 0px;
        font-family: 'Arial Italic', 'Arial';
        font-weight: 400;
        font-style: italic;
        cursor: pointer;
      }
    }
  }

  .add_btn_data {
    position: relative;
    width: 100px;
    height: 40px;
    background: inherit;
    background-color: rgba(0, 153, 255, 1);
    border: none;
    border-radius: 5px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 20px;

    .style_icon_add {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      left: 0;
      bottom: 0;
      margin-left: 14px;
    }

    .style_text {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      height: fit-content;
      font-family: 'Arial Bold', 'Arial';
      font-weight: 700;
      font-style: normal;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
}
.box_add_service_park{
  padding-bottom: 0px;
  .service_park_child{
    padding-bottom: 0px;
    .item_add_service_park{
      padding-bottom: 0px;
    }
  }
}
</style>
<style>
.table_maintenance .p-datatable-auto-layout > .p-datatable-wrapper{
  overflow-x: unset !important;/*bỏ croll ngang table ảnh hưởng đến show dropdown lên*/
}
</style>